const lang = {
  label: {
    cooperator: '共同作業者',
    collaboration: '招待中',
    add_collaborator: '作業者追加'
  },
  button: {
    add: '追加',
    back: '戻る',
    select: '選択',
    cancel: 'キャンセル'
  },
  modal: {
    header: '削除確認',
    content: '<b>共同作業者が削除されます。</b><br>本当に削除してよろしいでしょうか？',
    button: {
      cancel: '削除しない',
      confirm: '削除する'
    }
  },
  email: 'メールアドレス',
  notice: '追加したい共同作業者のメールアドレスを入力してください。最大10人まで登録可能です。',
  input_placeholder: '入力してください',
  message_expired: '無料プラン会員のため、共同作業期間が終了しました。',
  empty_invite: '招待中の作業者はいません',
  people_left: 'あと{num}人追加可能',
  modal_content_decline: '<b>{mail}</b> <br>が共同作業の招待を拒否しました。',
  modal_send_invitation: '<b>{mail}</b><br> に招待メールを送信しますか？',
  modal_delete_user: '<b>{mail}</b></br>が削除されます。 </br>本当に削除してよろしいでしょうか？',
  owner: 'オーナー',
  member: '作業者',
  myself: '（自分）',
  delete_confirmation: '削除確認',
  cancel: 'キャンセル',
  delete: '削除する',
  notice_header: 'お知らせ',
  add_member: '作業者追加',
  send: '送信する',
  empty_name: '案件名未入力'
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/constructionUser.js